import { render, staticRenderFns } from "./TrackingNumberInput.vue?vue&type=template&id=488e773d&"
import script from "./TrackingNumberInput.vue?vue&type=script&lang=ts&"
export * from "./TrackingNumberInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports